// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1m6eg","icon":"EnquiryForm_icon__hciOo","heading":"EnquiryForm_heading__2R83E","field":"EnquiryForm_field__3X3HD","error":"EnquiryForm_error__13yvM"};